import React, { useState } from 'react';
import SubjectDropdown from '../helperComponent/SubjectDropdown';

const AddNotesForm = ({ addNotes }) => {
  const [title, setTitle] = useState('');
  const [price, setPrice] = useState(0);
  const [offerPrice, setOfferPrice] = useState(0);
  const [description, setDescription] = useState('');
  const [image, setImage] = useState([]);
  const [formData, setFormData] = useState([]);
  const [download, setDownload] = useState(false);
  const [sub, setSub] = useState('');

  // File data
  const handleUpload = (e) => {
    e.preventDefault();
    const file = e.target.files;
    setFormData(file[0]);
  };

  // Image upload
  const handleImageUpload = (e) => {
    e.preventDefault();
    const file = e.target.files;
    setImage(file[0]);
  };

  // handling add event
  const handleAddNotes = (e) => {
    e.preventDefault();
    addNotes({
      title,
      price,
      offerPrice,
      description,
      image,
      formData,
      download,
      sub,
    });
  };

  const handleChecked = (e) => {
    if (e.target.checked) {
      setDownload(true);
    }
  };

  //handle offer price
  const handleOfferPrice = (e) => {
    const op = e.target.value;
    if (op < 0) {
      setOfferPrice(0);
    } else if (parseInt(op, 10) > parseInt(price, 10)) {
      setOfferPrice(price);
    } else {
      setOfferPrice(e.target.value);
    }
  };

  return (
    <form className='class-form' onSubmit={(e) => handleAddNotes(e)}>
      <div className='form-control'>
        <label htmlFor='title'>Notes Title</label>
        <input
          type='text'
          value={title}
          required
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='item'>Description</label>
        <textarea
          type='text'
          value={description}
          required
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
      </div>
      <div className='form-control'>
        <label htmlFor='subject'>Subject</label>
        <SubjectDropdown setSub={setSub} />
      </div>
      <div className='form-control'>
        <label htmlFor='price'>Price</label>
        <input
          type='number'
          value={price}
          required
          onChange={(e) => setPrice(e.target.value < 0 ? 0 : e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='offerPrice'>Offer Price</label>
        <input
          type='number'
          value={offerPrice}
          required
          onChange={(e) => handleOfferPrice(e)}
        />
      </div>

      <div className='form-control'>
        <label htmlFor='image'>Preview Image</label>
        <input
          type='file'
          name='uploadImage'
          required
          accept='image/x-png,image/gif,image/jpeg'
          onChange={(e) => handleImageUpload(e)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='file'>Upload File</label>
        <input
          type='file'
          name='uploadFile'
          required
          accept='application/pdf'
          onChange={(e) => handleUpload(e)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='downloadable'>Downloadable</label>
        <input type='checkbox' required onChange={(e) => handleChecked(e)} />
      </div>
      <button type='submit' className='btn'>
        Upload Notes
      </button>
    </form>
  );
};

export default AddNotesForm;
